import {catchError, map} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {Injectable} from "@angular/core";
import {IUser} from "./../models/user/user";
import {LocalStorageService} from "./../services/local-storage/local-storage.service";
import {Observable, of} from "rxjs";
import {UserService} from "./../services/user/user.service";
import {HttpService} from "../http/http.service";
import {jwtDecode} from "jwt-decode";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  public companyData: IUser;

  constructor(
    private httpService: HttpService,
    private _storage: LocalStorageService,
    private _user: UserService
  ) {
  }

  validateAuthToken(): Observable<boolean> {
    const jwtValue: any = this._user.getJWTValue();
    this.companyData = jwtValue.business;

    return this.httpService
      .post<any>(
        environment.SEGURIDAD.API_AUTENTICACION_URL,
        "/transaccional/auth",
        {
          idNum: this.companyData.docNumberCompany,
          idType: this.companyData.docTypeCompany,
        },
        {},
        {},
        {observe: "response"}
      )
      .pipe(
        map((response) => {
          this._storage.stringifyItem(
            environment.LOCAL_STORAGE.USER_LOGGED_IN,
            this.companyData
          );
          const token = response.headers.get("Authorization");
          if (token) {
            const onlyToken = token.replace("Bearer ", "");
            this._storage.setItem(environment.LOCAL_STORAGE.AUTHORIZATION_TOKEN, onlyToken);
            return true;
          } else {
            return false;
          }
        }),
        catchError((err) => {
          return of(false);
        })
      );
  }

  decodeJWT(token: string): any {
    if (!token) return null;
    try {
      return jwtDecode(token); // Devuelve el payload como objeto
    } catch (error) {
      console.error('Error decoding JWT', error);
      return null;
    }
  }
}
